import {BaseModel} from '@/models/base.model';

export class TablePlatformSettingsModel extends BaseModel {
    constructor(public timezone?: string,
                public notification_config?: NotificationSettingsModel) {
        super()
        this.notification_config = new NotificationSettingsModel();
    }
}

export class NotificationSettingsModel {
    all_challenges: { [key: string]: PlatformSettingMessagesModel } = {
        new_challenge: {platform: true, email: true},
    };
    my_challenges: { [key: string]: PlatformSettingMessagesModel } = {
        updates: {platform: true, email: true},
        forum: {email: true, platform: true},
        tasks: {platform: true, email: true},
    };
    platform: { [key: string]: PlatformSettingMessagesModel } = {
        ikone_notifications: {email: true, platform: true},
    }
}

export interface PlatformSettingMessagesModel {
    platform: boolean;
    email: boolean;
}
